import { FormGroup } from '@mui/material';
import PropTypes from 'prop-types';
import PublisherControlItem from './PublisherControlItem';
import PublisherDisplayItem from './PublisherDisplayItem';

const PublisherSection = ({ publishers, isCustomList, nameBase }) => {
  if (isCustomList) {
    return (
      <FormGroup>
        {publishers.map(publisher => (
          <PublisherControlItem key={`${nameBase}_${publisher.id}`} {...publisher} nameBase={nameBase} />
        ))}
      </FormGroup>
    );
  }

  return (
    <ul>
      {publishers.map(publisher => (
        <PublisherDisplayItem key={`${nameBase}.${publisher.id}`} {...publisher} />
      ))}
    </ul>
  );
};

PublisherSection.propTypes = {
  publishers: PropTypes.array,
  isCustomList: PropTypes.bool,
  nameBase: PropTypes.string,
};

export default PublisherSection;
